export class LocationData {
    yextId?: string;
    oloId?: string;
    oloUrl?: string;
    yextUrl?: string;
    name?: string;
    phoneNumber?: string;

    constructor(init?: Partial<LocationData>) {
        Object.assign(this, init);
    }

    public Init(): LocationData {
        Object.assign(this, LocationData.Get());
        return this;
    }

    public Set<K extends keyof LocationData>(key: K, value: LocationData[K]) {
        this[key] = value as any;
        this.persist();
    }

    public static Get(): LocationData {
        if ('localStorage' in window) {
            const data = window.localStorage.getItem('location-data');
            if (data) {
                return new LocationData(JSON.parse(data));
            }
        }

        return new LocationData();
    }

    private persist() {
        if ('localStorage' in window) {
            window.localStorage.setItem('location-data', JSON.stringify(this));
        }
    }
}
